// extracted by mini-css-extract-plugin
export var alt = "Layout-module--alt--98636";
export var container = "Layout-module--container--bccea";
export var desktopOnly = "Layout-module--desktopOnly--5432b";
export var footer = "Layout-module--footer--c9189";
export var header = "Layout-module--header--83d38";
export var layoutWrapper = "Layout-module--layoutWrapper--0fd06";
export var main = "Layout-module--main--2f9d7";
export var mobileOnly = "Layout-module--mobileOnly--cb7b0";
export var skipToContentLink = "Layout-module--skipToContentLink--300dd";
export var textLeft = "Layout-module--textLeft--7b7a3";
export var visuallyHidden = "Layout-module--visuallyHidden--757d6";